/**
 * formatValue — stringify a raw CRM property value for display in proposal
 * previews and fields.
 *
 * Lives in its own leaf module (rather than CreateActionCard.helpers) so the
 * content components registered in ENTITY_CONTENT_REGISTRY can use it without
 * importing a value back from the registry file, which would form a runtime
 * module cycle.
 */
import { formatMaybeMultiValue } from '@/lib/crm/utils/formatMultiValue';

export function formatValue(v: unknown): string {
  if (v === null || v === undefined) {
    return '';
  }
  if (typeof v === 'string') {
    return v;
  }
  if (typeof v === 'number' || typeof v === 'boolean') {
    return String(v);
  }
  if (Array.isArray(v)) {
    return formatMaybeMultiValue(v);
  }
  return JSON.stringify(v);
}
